/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import { Dialog, Grid, Skeleton, VisuallyHidden } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import _t from 'i18n!nls/account-profile';

const { Actions, Content, HeadingGroup } = Dialog;

const styles = {
  projectCardSkeleton: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(12)};
    border-radius: 16px;
  `,
  filterLabelWrapper: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(8)};
    height: 28px;
  `,
  largeTopPadding: (theme: Theme) => css`
    padding-top: ${theme.spacing(48)};
  `,
};

type PropsFromCaller = {
  isOpen: boolean;
  onClose: () => void;
};

export const BrowseProjectsDialogPlaceholder = ({ isOpen, onClose }: PropsFromCaller) => {
  return (
    <Dialog color="darkBlue" width="large" open={isOpen} onClose={onClose}>
      <HeadingGroup
        title={_t('Browse Projects')}
        supportText={_t(
          'Projects give you real-world challenges to solve with industry tools, and produce work samples that help you demonstrate your capabilities and stand out.'
        )}
      >
        {_t('Browse Projects')}
      </HeadingGroup>

      <Content>
        <div>
          <VisuallyHidden role="status">{_t('Loading filters and project cards')}</VisuallyHidden>

          <Skeleton variant="rect" css={styles.filterLabelWrapper} height="28px" key="filter-label-skeleton" />

          <Skeleton variant="rect" height="32px" key="chips-skeleton" />

          <Grid container direction="column" css={styles.largeTopPadding}>
            <Grid item key="item1">
              <Skeleton variant="rect" height="142px" key="skeleton-1" css={styles.projectCardSkeleton} />
            </Grid>
            <Grid item key="item2">
              <Skeleton variant="rect" height="142px" key="skeleton-2" css={styles.projectCardSkeleton} />
            </Grid>
          </Grid>
        </div>
      </Content>

      <Actions>
        <Skeleton height="48px" key="cta-skeleton" />
      </Actions>
    </Dialog>
  );
};

export default BrowseProjectsDialogPlaceholder;
